<template>
  <Layout
    contentClass="general"
    bgImg="default"
    pageTitle="AXA Dijital Sağlık Sigortası Teklifi Alın"
    pageTitleIcon=""
    pageSubtitle="Kendiniz ya da aileniz için doktor muayenesine evinizin rahatlığında erişin."
    :step="1"
    :fixedPhone="true"
    :loading="store.loading"
  >
    <div class="form bilgi-label">
      <div class="item">
        <div class="label">
          T.C. Kimlik Numarası
          <Tooltip
            content="T.C. Kimlik numaranı sana özel olarak fiyat çalışması hesaplayabilmek için istiyoruz. T.C. Kimlik numaran ve diğer kişisel bilgilerinin gizliliği AXA SİGORTA güvencesi altındadır."
          />
        </div>
        <div class="input">
          <XInput
            type="kimlikNo"
            placeholder="11 Haneli Kimlik Numarası"
            v-model="store.sigortali.kimlikNo"
          />
        </div>
        <ValidationError :message="this.validationErrorSigortaliKimlikNo" />
      </div>

      <div class="item">
        <div class="label">Doğum Tarihi</div>
        <div class="input">
          <XInput type="dogumTarihi" v-model="store.sigortali.dogumTarihi" />
        </div>
        <ValidationError :message="this.validationErrorSigortaliDogumTarihi" />
      </div>

      <div class="item">
        <div class="label">E-posta Adresi</div>
        <div class="input">
          <XInput
            type="ePosta"
            placeholder="E-posta Adresi"
            v-model="store.sigortali.ePosta"
          />
        </div>
        <ValidationError :message="this.validationErrorSigortaliEPosta" />
      </div>

      <div class="item">
        <div class="label">Cep Telefonu Numarası</div>
        <div class="input">
          <XInput
            type="cepNo"
            placeholder="Cep Telefonu Numarası"
            v-model="store.sigortali.cepNo"
          />
        </div>
        <ValidationError :message="this.validationErrorSigortaliCepNo" />
      </div>

      <Captcha
        :imageSrc="store.captcha.imageSrc"
        :error="this.validationErrorCaptcha"
        v-model="store.captcha.input"
        @reload="store.getCaptcha"
      />

      <div class="item">
        <div class="radio-checkbox">
          <ul>
            <li>
              <!-- <XInput
                type="check"
                v-model="store.sigortali.gizlilikSozlesmeOnay"
              >
                Kişisel verilere yönelik
                <a @click="store.setLegalNoticePopupName('GizlilikSozlesmesi')"
                  >Aydınlatma Metni</a
                >’ni okudum, aydınlatma yapıldığını kabul ediyorum.
              </XInput> -->
              <XInput
                type="check"
                v-model="store.sigortali.gizlilikSozlesmeOnay"
              >
                Kişisel verilere yönelik
                <a href="https://www.axasigorta.com.tr/kisisel-verilerin-korunmasina-iliskin-aydinlatma-bildirimi " target="_blank"
                  >Aydınlatma Metni</a
                >’ni okudum, aydınlatma yapıldığını kabul ediyorum.
              </XInput>
            </li>
            <!-- <li>
              <XInput
                type="check"
                v-model="store.sigortali.elektronikIletiOnay"
              >
                Tarafıma
                <a
                  @click="
                    store.setLegalNoticePopupName('ElektronikIletiSozlesmesi')
                  "
                  >ticari elektronik ileti</a
                >
                gönderilmesine onay veriyorum.
              </XInput>
            </li> -->
          </ul>
        </div>
        <ValidationError :message="this.validationErrorBilgilerSozlesmeler" />
      </div>

      <div class="item">
        <div class="submit">
          <button
            class="button red-btn button-block"
            @click="this.CheckUserCampaignPermission()"
          >
            DEVAM ET
          </button>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import { store } from "@/store";
import service from "@/utils/service";
import validator from "@/utils/validators";

const newService = new service();

export default {
  data() {
    return {
      store,
      clarityScript1: null ,
      clarityScript2: null 
    };
  },
  created() {
    (async () => {
      await newService.GetCaptcha({
        onSuccess: (response) => {
          store.captcha.code = response.code;
          store.captcha.imageSrc = response.imageSrc;
        },
      });
    })();
  }, mounted() {

    var clarity1 = document.createElement("script");
        var clarityText1 = document.createTextNode(`
                        (function(c,l,a,r,i,t,y){
                c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
                t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
                y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
            })(window, document, "clarity", "script", "oiyuiah75r");
                    `);
        clarity1.appendChild(clarityText1);

        var clarity2 = document.createElement("script");
        var clarityText2 = document.createTextNode(`
                        (function(c,l,a,r,i,t,y){
                c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
                t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
                y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
            })(window, document, "clarity", "script", "oiyg2rilu7");
                    `);
        clarity2.appendChild(clarityText2);

        this.clarityScript1 = document.head.appendChild(clarity1);
        this.clarityScript2 = document.head.appendChild(clarity2);
  },
  computed: {
    validationErrorSigortaliKimlikNo() {
      if (!store.formSubmitted) {
        return null;
      }
      return (
        validator.required(
          store.sigortali.kimlikNo,
          "Lütfen T.C. Kimlik Numaranızı girin."
        ) ?? validator.kimlikNo(store.sigortali.kimlikNo)
      );
    },
    validationErrorSigortaliDogumTarihi() {
      if (!store.formSubmitted) {
        return null;
      }
      return (
        validator.required(
          store.sigortali.dogumTarihi,
          "Lütfen doğum tarihinizi girin."
        ) ?? validator.dogumTarihi(store.sigortali.dogumTarihi)
      );
    },
    validationErrorSigortaliCepNo() {
      if (!store.formSubmitted) {
        return null;
      }
      return (
        validator.required(
          store.sigortali.cepNo,
          "Lütfen cep telefon numaranızı girin."
        ) ?? validator.cepNo(store.sigortali.cepNo)
      );
    },
    validationErrorSigortaliEPosta() {
      if (!store.formSubmitted) {
        return null;
      }
      return (
        validator.required(
          store.sigortali.ePosta,
          "Lütfen e-posta adresinizi girin."
        ) ?? validator.ePosta(store.sigortali.ePosta)
      );
    },
    validationErrorCaptcha() {
      if (!store.captcha.touched) {
        return null;
      }
      return (
        validator.required(
          store.captcha.input,
          "Lütfen güvenlik metnini girin."
        ) ?? store.captcha.error
      );
    },
    validationErrorBilgilerSozlesmeler() {
      if (!store.formSubmitted) {
        return null;
      }
      if (
        store.sigortali.gizlilikSozlesmeOnay
      ) {
        return null;
      }
      return "Size özel online fiyat çalışması yapabilmemiz için yukarıdaki metni okuyup onaylamanıza ihtiyacımız var.";
    },
    validationErrorElektronikIletiSozlesmesi(){
      if(store.sigortali.elektronikIletiOnay){
        return null;
      }
      return "Sana özel online fiyat çalışması yapabilmemiz için onayına ihtiyacımız var.";
    }
  },
  methods: {
    async checkCaptcha() {
      return await newService.CheckCaptcha({
        code: store.captcha.code,
        input: store.captcha.input,
        onSuccess: () => {
          store.captcha.error = null;
        },
      });
    },
    hasValidationError(errors) {
      let hasError = errors.find((i) => {
        return i !== null;
      });

      if (hasError) {
        /* Vue.nextTick(() => {
                        let errorMessage = document.querySelector('.input-error.invalid')
                        if (errorMessage) {
                            let closest = errorMessage.closest(".item")
                            let invalidInput = closest.querySelector('input')
                            if (invalidInput) {
                                invalidInput.focus()
                            }
                            setTimeout(() => {
                                closest.scrollIntoView({ behavior: 'smooth', block: 'center' })
                            }, 100)
                        }
                    }) */
      }

      return hasError;
    },
    async CheckUserCampaignPermission(){
      store.formSubmitted = true;
      store.captcha.touched = true;

      if (
        this.hasValidationError([
          this.validationErrorSigortaliKimlikNo,
          this.validationErrorSigortaliDogumTarihi,
          this.validationErrorSigortaliCepNo,
          this.validationErrorSigortaliEPosta,
          this.validationErrorCaptcha,
          this.validationErrorBilgilerSozlesmeler,
        ])
      ) {
        return;
      }

      store.loading = true;

      var checkCaptchaResponse = await this.checkCaptcha();

      if (checkCaptchaResponse?.data?.Mesajlar?.length > 0) {
          store.captcha.error = "Geçersiz bir güvenlik metni girdin.";
          store.loading = false;
          return;
      }

      await newService.GetToken({
        code: store.captcha.code,
        input: store.captcha.input,
        onSuccess: (response) => {
          store.token = response?.data?.access_token;
        },
        onError: (response) => {
          store.error = {
            message: response?.message,
          };
        },
      });

      await newService.CheckUserCampaignPermission({
        Tckn: store.sigortali.kimlikNo,
        onSuccess: (response) => {
          store.isCheckUserPermission = JSON.parse(response.data.Data.Result).Result;
          if(!store.isCheckUserPermission){
            store.setLegalNoticePopupName('CampaignPermission')
          }else{
            store.formSubmit();
          }
        },
        onError: () => {
          store.isCheckUserPermission = false;
        }
      });
    },
  },
};
</script>
